import { g as d } from "../../utils-BOfnFgIH.js";
import { I as i } from "../../constants-DeVuDy8J.js";
import { createElementBlock as n, openBlock as s, normalizeClass as o, createElementVNode as a } from "vue";
import { _ as r } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconLanguages",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = d();
  }
}, u = ["aria-label", "data-qa", "aria-hidden"], _ = ["clip-path"], h = /* @__PURE__ */ a("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3 1a.5.5 0 0 1 .5-.5H4a.5.5 0 0 1 0 1h-.5A.5.5 0 0 1 3 1Z"
}, null, -1), p = /* @__PURE__ */ a("path", { d: "M2.146 3.646a.5.5 0 0 1 .708 0l.896.897.861-.862L5.066 3H1a.5.5 0 0 1 0-1h6a.5.5 0 0 1 0 1h-.732l-.852 1.277a.5.5 0 0 1-.062.077l-.897.896 1.397 1.396a.5.5 0 1 1-.708.708L3.75 5.957 2.354 7.354a.5.5 0 1 1-.708-.708L3.043 5.25l-.897-.896a.5.5 0 0 1 0-.708Z" }, null, -1), f = /* @__PURE__ */ a("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8.5 5.5a.5.5 0 0 1 .447.276l2.5 5a.5.5 0 1 1-.894.448L9.69 9.5H7.309l-.862 1.724a.5.5 0 1 1-.894-.448l2.5-5A.5.5 0 0 1 8.5 5.5Zm-.691 3L8.5 7.118 9.191 8.5H7.809Z"
}, null, -1), m = [
  h,
  p,
  f
], g = ["id"], v = /* @__PURE__ */ a("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
}, null, -1), L = [
  v
];
function I(e, b, l, q, H, t) {
  return s(), n("svg", {
    "aria-label": l.ariaLabel,
    class: o([t.iconSizeClass, "d-icon d-icon--languages"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Languages",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`,
      fill: "currentColor"
    }, m, 8, _),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, L, 8, g)
    ])
  ], 10, u);
}
const D = /* @__PURE__ */ r(c, [["render", I]]);
export {
  D as default
};
//# sourceMappingURL=languages.js.map
